import { baseApi } from '@/services/api';
import { Venue } from './venuesTypes';

export const venuesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get Venues
    getVenues: builder.query<
      {
        venues: Venue[];
        total: number;
        page: number;
        limit: number;
        pages: number;
      },
      {
        city?: string;
        capacity_min?: number;
        capacity_max?: number;
        search?: string;
        page?: number;
        limit?: number;
      } | void
    >({
      query: (params = {}) => ({
        url: '/venues',
        method: 'GET',
        params,
      }),
      providesTags: ['Venues'],
    }),
    
    // Get Venue
    getVenue: builder.query<Venue, string>({
      query: (venueId) => ({
        url: `/venues/${venueId}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Venues', id }],
    }),
    
    // Create Venue
    createVenue: builder.mutation<Venue, Partial<Venue>>({
      query: (data) => ({
        url: '/venues',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Venues'],
    }),
    
    // Update Venue
    updateVenue: builder.mutation<
      Venue,
      { venueId: string; updates: Partial<Venue> }
    >({
      query: ({ venueId, updates }) => ({
        url: `/venues/${venueId}`,
        method: 'PUT',
        data: updates,
      }),
      invalidatesTags: (result, error, { venueId }) => [
        { type: 'Venues', id: venueId },
        'Venues',
      ],
    }),
    
    // Delete Venue
    deleteVenue: builder.mutation<{ message: string }, string>({
      query: (venueId) => ({
        url: `/venues/${venueId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Venues'],
    }),
  }),
});

export const {
  useGetVenuesQuery,
  useLazyGetVenuesQuery,
  useGetVenueQuery,
  useLazyGetVenueQuery,
  useCreateVenueMutation,
  useUpdateVenueMutation,
  useDeleteVenueMutation,
} = venuesAPI;
